import api from '../../../api/client'

function toQuery(params = {}) {
  const searchParams = new URLSearchParams()
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === '' || value === null || value === undefined) return
    searchParams.set(key, String(value))
  })
  const query = searchParams.toString()
  return query ? `?${query}` : ''
}

export async function fetchUserAnalyticsFilters(params = {}) {
  const { data } = await api.get(`/analytics/user/filters${toQuery(params)}`)
  return data || { users: [], departments: [], datePresets: [] }
}

export async function fetchUserAnalyticsInsights(params = {}) {
  const { data } = await api.get(`/analytics/user/insights${toQuery(params)}`)
  return data || {}
}

export async function fetchUserAnalyticsDrilldown(params = {}) {
  const { data } = await api.get(`/analytics/user/drilldown${toQuery(params)}`)
  return data || { level: 'productivity', columns: [], rows: [] }
}

export async function downloadUserAnalyticsExport(params = {}) {
  const response = await api.get(`/analytics/user/export${toQuery(params)}`, {
    responseType: 'blob',
  })
  return response.data
}

export async function fetchProjectAnalyticsFilters(params = {}) {
  const { data } = await api.get(`/analytics/project/filters${toQuery(params)}`)
  return data || { projects: [], departments: [], datePresets: [] }
}

export async function fetchProjectAnalyticsInsights(params = {}) {
  const { data } = await api.get(`/analytics/project/insights${toQuery(params)}`)
  return data || {}
}

export async function fetchProjectAnalyticsDrilldown(params = {}) {
  const { data } = await api.get(`/analytics/project/drilldown${toQuery(params)}`)
  return data || { level: 'project', columns: [], rows: [] }
}

export async function downloadProjectAnalyticsExport(params = {}) {
  const response = await api.get(`/analytics/project/export${toQuery(params)}`, {
    responseType: 'blob',
  })
  return response.data
}

export async function fetchProjectCompletionBreakdown(params = {}) {
  const { data } = await api.get(`/analytics/project/completion-breakdown${toQuery(params)}`)
  return data || {}
}

export async function fetchTaskAnalyticsFilters(params = {}) {
  const { data } = await api.get(`/analytics/task/filters${toQuery(params)}`)
  return data || { departments: [], projects: [], datePresets: [] }
}

export async function fetchTaskAnalyticsInsights(params = {}) {
  const { data } = await api.get(`/analytics/task/insights${toQuery(params)}`)
  return data || {}
}

export async function fetchTaskAnalyticsTeamLoad(params = {}) {
  const { data } = await api.get(`/analytics/task/team-load${toQuery(params)}`)
  return data || { contributors: [], teamBreakdown: {} }
}

export async function fetchTaskAnalyticsRiskList(params = {}) {
  const { data } = await api.get(`/analytics/task/risk-list${toQuery(params)}`)
  return data || { data: [], counts: {} }
}

export async function fetchTaskAnalyticsRiskExport(params = {}) {
  const { data } = await api.get(`/analytics/task/risk-export${toQuery(params)}`)
  return data || { columns: [], rows: [] }
}

export async function fetchTaskAnalyticsDrilldown(params = {}) {
  const { data } = await api.get(`/analytics/task/drilldown${toQuery(params)}`)
  return data || { level: 'task', columns: [], rows: [] }
}

export async function downloadTaskAnalyticsExport(params = {}) {
  const response = await api.get(`/analytics/task/export${toQuery(params)}`, {
    responseType: 'blob',
  })
  return response.data
}

export async function fetchJobAnalyticsFilters(params = {}) {
  const { data } = await api.get(`/analytics/job/filters${toQuery(params)}`)
  return data || { projects: [], resourcePools: [], datePresets: [] }
}

export async function fetchJobAnalyticsInsights(params = {}) {
  const { data } = await api.get(`/analytics/job/insights${toQuery(params)}`)
  return data || {}
}

export async function fetchJobAnalyticsDrilldown(params = {}) {
  const { data } = await api.get(`/analytics/job/drilldown${toQuery(params)}`)
  return data || { columns: [], rows: [], total: 0 }
}

export async function downloadJobAnalyticsExport(params = {}) {
  const response = await api.get(`/analytics/job/export${toQuery(params)}`, { responseType: 'blob' })
  return response.data
}
